<div class="container py-4" style="max-width: 720px">
    @if (missing) {
        <p>This site link is not valid.</p>
    }
    @if (site) {
        <h1>Van Con Inc.</h1>
        <p class="lead">We Dig Utah</p>
        <h2 class="h4">{{ site.siteName }}</h2>
        <p>Job {{ site.job }}</p>
        <p>{{ site.address }}</p>
        <p>{{ site.latitude }}, {{ site.longitude }}</p>
        <h3 class="h5">Contacts</h3>
        @for (contact of site.contacts; track contact.id) {
            <p>{{ contact.name }}<br />{{ contact.phone }}<br />{{ contact.email }}</p>
        }
    }
</div>
